import {Attribute, Directive, Injector, OnInit, Optional} from '@angular/core';

import {IWidgetConfig, Parent, provideAsWidgetRef, register, StylableComponent, styler} from "@wm/components-base";

const DEFAULT_CLS = 'app-html-container';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-html',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmHtml]',
  providers: [
  provideAsWidgetRef(HtmlDirective)
  ],
  standalone: true,
  exportAs: 'wmHtml'
})
export class HtmlDirective extends StylableComponent implements OnInit{
  static initializeProps = register('wm-html');

  public content: string;

  constructor(inj: Injector, @Optional() viewParent: Parent,
              @Attribute('content.bind') private boundContent: string
              ) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  override ngOnInit() {
    super.ngOnInit();
    if (!this.content && this.nativeElement.innerHTML) {
      this.content = this.nativeElement.innerHTML;
    }
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'content') {
      this.nativeElement.innerHTML = nv;
    }
    if (key === 'height') {
      this.nativeElement.style.overflow = nv? 'auto': '';
    }
    super.onPropertyChange(key, nv, ov);
  }
}

